/*************************************************/
/* INVIEW                                        */
/*************************************************/
import inView from "../vendor/in-view.min.js";

export function inview() {
    let inViewActiveClass,
        $inViewElements;

    const init = function () {
        inViewActiveClass = "in-view",
            $inViewElements = [
                ".pagehead",
                ".pagehead-contact",
                ".pagehead-frontpage"
            ];

        inView.offset(200);

        $.each($inViewElements, function (i) {
            const $currentElement = $inViewElements[i];
            inView($currentElement).on("enter", function (t) {
                return t.classList.add($currentElement.substring(1) + "--" + inViewActiveClass);
            }).on("exit", function (t) {
                //return t.classList.remove($currentElement.substring(1) + "--" + inViewActiveClass);
            });
        });

        window.dispatchEvent(new Event('resize'));

    };

    init();
}